import React from 'react';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography/Typography';
import Tooltip from '@mui/material/Tooltip/Tooltip';

interface ISoonProps {
  disableMargin?: boolean;
}

export default function Soon({ disableMargin }: ISoonProps) {
  const theme = useTheme();

  return (
    <>
      <Tooltip title='In Development' placement='top'>
        <div
          style={{
            margin: disableMargin ? 'auto' : 'auto 15px auto auto',
            padding: '1px 10px',
            background: theme.palette.bgFive.main,
            borderRadius: 5,
            color: theme.palette.gray.main,
            display: 'flex',
            justifyContent: 'center',
            textTransform: 'uppercase',
          }}
        >
          <Typography variant='subtitle2'>soon</Typography>
        </div>
      </Tooltip>
    </>
  );
}

export function SoonButton() {
  const theme = useTheme();

  return (
    <>
      <Tooltip title='In Development' placement='top'>
        <div
          style={{
            margin: '10px 13.4px',
            padding: '6px 16px',
            background: theme.palette.secondary.light,
            borderRadius: 4,
            color: theme.palette.secondary.contrastText,
            minWidth: 64,
            display: 'flex',
            justifyContent: 'center',
            textTransform: 'uppercase',
          }}
        >
          <Typography variant='subtitle2'>soon</Typography>
        </div>
      </Tooltip>
    </>
  );
}

interface ISoonWrapperProps {
  children: React.ReactNode;
}

export function SoonWrapper({ children }: ISoonWrapperProps) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 32 }}>
      {children}
      <Soon />
    </div>
  );
}
